export enum MessageType {
  UNSET_MESSAGE_TYPE = 'UNSET_MESSAGE_TYPE', // Do not use, needed because of proto3 limitations
  SMS = 'SMS',
  APP = 'APP',
}
